import i18n from "dynamic/translations/i18n";
import { ZIP_CODE_LENGTH } from "constants/inputMasks";
import isValidZipCode from "utils/isValidZipCode";

/**
 * Applies zip code validation in one schema field.
 */
const zipCodeTest = {
  name: "isValidZipCode",
  exclusive: false,
  test: isValidZipCode,
  message: i18n.t("yup.invalid_field_length", {
    min: ZIP_CODE_LENGTH,
  }),
};

export default zipCodeTest;
